import { memo } from 'react';

import HandshakeColorlessIcon from '@/assets/icons/handshake-colorless.svg?react';
import {
  ProgressCircleIndicator,
  type ProgressCircleIndicatorProps,
} from '@/shared/components/progressCircleIndicator';

export interface ProfileFitIndicatorProps extends Omit<
  ProgressCircleIndicatorProps,
  'icon' | 'progress'
> {
  progress: number;
}

export const ProfileFitIndicator = memo(function ProfileFitIndicator({
  progress,
  ...props
}: ProfileFitIndicatorProps) {
  return (
    <ProgressCircleIndicator
      progress={progress}
      icon={<HandshakeColorlessIcon className="size-7" />}
      {...props}
    />
  );
});
